/** MC Dashboard — operational control: agenda, Who Will, crossword reveal, feed moderation. */
import { useNavigate } from "react-router-dom";
import StaffShell from "../components/StaffShell";
import MCAgendaPanel from "../components/MCAgendaPanel";
import WhoWillControlPanel from "../components/WhoWillControlPanel";
import CrosswordChampionPanel from "../components/CrosswordChampionPanel";
import FeedModerationPanel from "../components/FeedModerationPanel";
import { LayoutDashboard, Presentation } from "lucide-react";
import { T, useI18n } from "../lib/i18n";

export default function MCDash() {
  useI18n();
  const navigate = useNavigate();
  return (
    <StaffShell title={T("MC console")} subtitle={T("Run the show")}>
      {/* View toggle */}
      <div className="flex gap-2 mb-6 justify-center" data-testid="mc-view-toggle">
        <button
          className="text-xs tracking-luxe px-4 py-2 rounded-full flex items-center gap-2"
          style={{ background: "var(--motif-primary)", color: "var(--motif-primary-fg)" }}
          data-testid="mc-toggle-dashboard"
        >
          <LayoutDashboard className="w-3.5 h-3.5" /> {T("DASHBOARD")}
        </button>
        <button
          onClick={() => navigate("/mc/show")}
          className="text-xs tracking-luxe px-4 py-2 rounded-full flex items-center gap-2"
          style={{ background: "var(--motif-accent)", color: "var(--motif-text-muted)" }}
          data-testid="mc-toggle-show"
        >
          <Presentation className="w-3.5 h-3.5" /> {T("SHOW")}
        </button>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <div className="space-y-4">
          <MCAgendaPanel />
          <CrosswordChampionPanel />
        </div>
        <div className="space-y-4">
          <WhoWillControlPanel />
          <FeedModerationPanel />
        </div>
      </div>
    </StaffShell>
  );
}
